module.exports = __webpack_public_path__ + "static/media/return_arrow.db707269.svg";